import axios from "axios";

axios.defaults.withCredentials = true;

// Désactiver le cache
axios.defaults.headers.common["Cache-Control"] = "no-cache";
axios.defaults.headers.common["Pragma"] = "no-cache";
axios.defaults.headers.common["Expires"] = "0";

const hostname = window.location.hostname;

let backendURL = "";

if (hostname === "localhost") {
    backendURL = "http://localhost:3001/api";
}
else if (hostname === "192.168.88.180") {
    backendURL = "http://192.168.88.180:3001/api";
}
else {
    backendURL = process.env.REACT_APP_API_BASE_URL;
}

axios.defaults.baseURL = backendURL;


axios.interceptors.response.use(
    (response) => response,
    (error) => {

        // 401 = token invalide/expiré => déconnexion forcée, retour login
        // 403 = token valide mais droits insuffisants => on reste sur la page,
        //        le composant affiche juste le toast d'erreur du backend
        if (
            error.response?.status === 401 &&
            !window.location.pathname.includes("/dcca") &&
            window.location.pathname !== "/" &&       // Protège la page d'accueil
            window.location.pathname !== "/login"     // Évite les boucles

        ) {
            window.location.href = "/login";
            localStorage.removeItem("token");

        }

        return Promise.reject(error);
    }
);

// 🔐 Intercepteur de REQUÊTE : attache automatiquement le token à chaque appel
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default axios;